import React from "react";
import axios from "axios";
import {
  authAppIdCookieName,
  generateRequestConfig,
} from "./constants";
import { ErrorAction, CsrfState } from "./interfaces";
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

let csrfTokenCache: string | null = null;
let csrfTokenExpiresAt = 0;

const APP_LOGO_ASSET_VERSION = "20260904-1";
const APP_LOGO_ASSET_ORIGIN = "https://id.express";

export const resolveAppLogoUrl = (
  urlImage?: string,
  currentOrigin: string = window.location.origin
): string | undefined => {
  if (!urlImage) return urlImage;

  try {
    const logoUrl = new URL(urlImage);

    if (
      logoUrl.origin === APP_LOGO_ASSET_ORIGIN &&
      logoUrl.pathname.startsWith("/assets/i/")
    ) {
      const environmentUrl = new URL(currentOrigin);
      logoUrl.protocol = environmentUrl.protocol;
      logoUrl.host = environmentUrl.host;
      logoUrl.searchParams.set("v", APP_LOGO_ASSET_VERSION);
    }

    return logoUrl.toString();
  } catch {
    return urlImage;
  }
};

export const fetchCsrfToken = async (
  setState: React.Dispatch<React.SetStateAction<CsrfState>>,
  setTimer?: (ms: number) => void  
): Promise<string | null> => {
  try {
    const requestConfigCSRF = generateRequestConfig(
      "get",
      "get_csrf_token",
      {},
      {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      }
    );

    const response = await axios(requestConfigCSRF);
    const { csrf_token, expires_in } = response.data;
    csrfTokenCache = typeof csrf_token === "string" ? csrf_token : null;
    csrfTokenExpiresAt = Date.now() + Number(expires_in || 900) * 1000;

    setState((prevState) => ({
      ...prevState,
      csrf_token,
    }));

    if (setTimer && expires_in) {
      setTimer(expires_in * 1000);  
    }
    return csrfTokenCache;
  } catch (error) {
    handleErrorForms(error);
    return null;
  }
};

export const ensureCsrfToken = async (token: string | null | undefined): Promise<string | null> => {
  if (csrfTokenCache && Date.now() < csrfTokenExpiresAt) return csrfTokenCache;
  if (token && !csrfTokenCache) return token;

  try {
    const response = await axios(
      generateRequestConfig(
        "get",
        "get_csrf_token",
        {},
        {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        }
      )
    );
    csrfTokenCache = typeof response.data.csrf_token === "string" ? response.data.csrf_token : null;
    csrfTokenExpiresAt = Date.now() + Number(response.data.expires_in || 900) * 1000;
    return csrfTokenCache;
  } catch (error) {
    handleErrorForms(error);
    return null;
  }
};




interface appInfo {
  _id?: string;
  appId?: string;
  name?: string;
  urlCallback?: string;
  [key: string]: any;
}

export const getAppInfo = async (setJsonData: (data: appInfo) => void) => {
  const appId = getIdApp();
  const ref = referer();

  try {
    
    const requestappInfo = generateRequestConfig(
      "get",
      "apps",
      {},
      { 
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        
      },
      {
        key: appId,
        status: "enabled",
        items_per_page: 1,
      }
    );
    
    const response = await axios(requestappInfo);
    const dictionaryApp = Array.isArray(response.data.data) ? response.data.data[0] : response.data.data;
    const appData = {
      ...(dictionaryApp?.metadata || {}),
      urlImage: resolveAppLogoUrl(dictionaryApp?.metadata?.urlImage),
      _id: dictionaryApp?._id,
      appId: dictionaryApp?.key || appId,
    };

    setJsonData(appData);
    
      if(!ref && appData.urlCallback){
        Cookies.set('referer', appData.urlCallback , { expires: 7 });
      }

  } catch (error) {
    handleErrorForms(error);
  }
};

export function handleErrorForms(error: any): ErrorAction | null {
  try {
    const { response } = error;

    if (!response) {
      return error.message ? { message: error.message } : null;
    }

    const { status, data } = response;
    const errorFields = ["email", "password", "passwordRepeat", "code"] as const;

    if (status === 503) {
      return {
        message: "Service is temporarily unavailable. Please try again later.",
        status,
      };
    }

    if (data.errors?.account?.[0]) {
      return { message: data.errors.account[0], status };
    }

    for (const field of errorFields) {
      if (data.errors?.[field]) {
        return { message: data.errors[field][0], field };
      }
    }

    const baseResponse = { message: data.message, status };

    if (status === 301 && data.redirect) {
      return { ...baseResponse, redirect: data.redirect };
    }

    if ([401, 403, 404, 429, 500].includes(status)) {
      return baseResponse;
    }

    return null;
  } catch {
    return { message: "Something went wrong" };
  }
}
export const getDeviceId = () => {
  let deviceId = Cookies.get('deviceId')
  
  if(!deviceId ){
    deviceId = uuidv4()
    Cookies.set('deviceId', deviceId, { expires: 365 });
    return deviceId
  }else{
      
    return deviceId;
  }
}
export const resetEmailInviteKeyIfNeeded = () => {
  const pathname = window.location.pathname;
  const isLoginOrRegister = pathname.includes('/login') || pathname.includes('/register');
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");
  if (isLoginOrRegister && (!email || email === 'null')) {
    Cookies.remove('invite_key');
    Cookies.remove('email');
  }
};

export const getInviteKey = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let referer = urlParams.get("invite_key");
  let refererCookie = Cookies.get('invite_key')
  
  if(referer && referer!='null' ){
    Cookies.set('invite_key', referer);
  }else{
     if(refererCookie){
      referer = refererCookie;
     }
  }
  if(referer)
    return referer;
  else 
    return null;
};

export const getEmail = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get("email");
  let emailCookie = Cookies.get('email')
  
  if(email && email!='null' ){
    Cookies.set('email', email);
  }else{
    resetEmailInviteKeyIfNeeded();
     if(emailCookie){
      email = emailCookie;
     }
  }
  if(email)
    return email;
  else 
    return null;
};

  export const getIdApp = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let referer = urlParams.get("appId");
  let refererCookie = Cookies.get(authAppIdCookieName)
  
  if(referer && referer!='null' ){
    Cookies.set(authAppIdCookieName, referer, { expires: 7 });
  }else{
     if(refererCookie){
      referer = refererCookie;
     }
  }
  if(referer)
    return referer;
  else 
    return null;
};

// Silent SSO (OIDC-style prompt=none) -- a per-request signal, never
// persisted to a cookie like appId/referer/email are for the multi-step
// registration flow.
export const getPrompt = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("prompt");
};

export const referer = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const requested = urlParams.get("referer");
  if (!requested || requested === "null") return null;

  try {
    const callback = new URL(requested, window.location.origin);
    if (!['http:', 'https:'].includes(callback.protocol)) return null;
    if (callback.origin === window.location.origin || callback.username || callback.password) return null;
    callback.searchParams.delete("login");
    callback.searchParams.delete("logout");
    return callback.toString();
  } catch {
    return null;
  }
};


export const getEmailFromParams = (): string | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  // Decode the URL-encoded email parameter
  const decodedEmail = email ? decodeURIComponent(email) : null;

  // Validate the decoded email using a regular expression
  if (decodedEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(decodedEmail)) {
    return decodedEmail;
  }
  return undefined;
};
